import { render, staticRenderFns } from "./drugsProtocolSetupManagement.vue?vue&type=template&id=62377028&scoped=true&"
import script from "./drugsProtocolSetupManagement.vue?vue&type=script&lang=js&"
export * from "./drugsProtocolSetupManagement.vue?vue&type=script&lang=js&"
import style0 from "./drugsProtocolSetupManagement.vue?vue&type=style&index=0&id=62377028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62377028",
  null
  
)

export default component.exports